// saved for later
// import config from 'config';
import {getPlayer} from './mockData/MockTeamAndPlayerData'


const LOAD = 'footballplayerprofile/LOAD';
const LOAD_SUCCESS = 'footballplayerprofile/LOAD_SUCCESS';
const LOAD_FAIL = 'footballplayerprofile/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [action.playerid]: {
          ...state[action.playerid],
          loading: true
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [action.playerid]: {
          ...state[action.playerid],
          loading: false,
          loaded: true,
          player: action.result
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [action.playerid]: {
          ...state[action.playerid],
          loading: false,
          loaded: false,
          error: action.error
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, playerid) {
  return globalState.football
      && globalState.football.playerProfile
      && globalState.football.playerProfile[playerid]
      && globalState.football.playerProfile[playerid].loading;
}

export function load(playerid) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: () => Promise.resolve(getPlayer(playerid)),
    playerid
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/playerProfile.js